import { useTypedParams } from 'react-router-typesafe-routes';

import style from './NotFound.module.scss';

import notFound from './not_found.svg?url';
import { Button } from '@components/Button';
import { CommonTestAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';
import { USER_NOT_FOUND_ROUTE } from './routes/userNotFoundRoute';

export function UserNotFound() {
    const { email } = useTypedParams(USER_NOT_FOUND_ROUTE);

    return (
        <div className={style.root}>
            <span className={style.code}>
                <img
                    alt={'User not found'}
                    src={notFound}
                />
            </span>
            <div className={style.message}>
                <p>
                    {translate('userWithEmail')} <b>{email}</b> {translate('notFound')}
                </p>
                <p>{translate('makeSureEmailText')}</p>
            </div>

            <a href="/api/auth/logout">
                <Button dataTest={CommonTestAttributes.Unknown}>{translate('tryAgain')}</Button>
            </a>
        </div>
    );
}
